'use client';

import lodash from 'lodash'

const toRupiah = (value) => {
  if(!value) return 0;
  return lodash.toNumber(value).toLocaleString("id-ID")
}

export default toRupiah